// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@babel/polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
// import store from "@/store/index";
import Slick from "vue-slick";
import Meta from "vue-meta";
import VueHead from "vue-head";
import VueLocalStorage from "vue-localstorage";
import GSignInButton from "vue-google-signin-button";
import FBSignInButton from "vue-facebook-signin-button";
import Carousel3d from "vue-carousel-3d";
import VueFriendlyIframe from "vue-friendly-iframe";
import VueScrollTo from "vue-scrollto";
import VeeValidate from "vee-validate";
import * as VueGoogleMaps from "vue2-google-maps";
import languageData from "@/languageData.json";
import languageDataksa from "@/languageDataksa.json";
import ReactSnapPixel from "react-snapchat-pixel";
import ReactPixel from "react-facebook-pixel";
import VueAnalytics from "vue-analytics";
// import VueTelInput from "vue-tel-input";
// import VueTelInput from "../src/components/telinput";
import { LanguageService, CountryService } from "@/services/storage.service";
import VCalendar from "v-calendar";
import VueFacebookPixel from "vue-facebook-pixel";

import "v-calendar/lib/v-calendar.min.css";
import VueQrcodeReader from "vue-qrcode-reader";
import Multiselect from "vue-multiselect";
import VueLazyload from "vue-lazyload";
import ReadMore from "vue-read-more";
import OTPInput from "vue-otp-input";
//LOADER COMPONENT
// Import component
import Loading from "vue-loading-overlay";
import VuePhoneNumberInput from "vue-phone-number-input";

import LightBox from "lightbox2";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
//import "intl-tel-input/build/css/intlTelInput.css";
import "@/assets/css/fancybox.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/css/header.css";
import "slick-carousel/slick/slick.css";
import "./assets/css/slick-theme.css";
import "./assets/css/ar.css";
// import "./assets/css/responsive.css"
import "animate.css";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import "./assets/css/newstyle.css";
// import "lightbox2/dist/css/lightbox.min.css";
// import "lightbox2/dist/js/lightbox.js";
// import "./assets/css/responsive.css"

Vue.use(BootstrapVue);
Vue.use(LightBox);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "/static/img/logo_p_ver.png",
  loading: "/static/img/logo_p_ver.png",
  attempt: 1,
});
// Vue.use(VueTelInput);
Vue.use(VueScrollTo);
Vue.use(VCalendar);
Vue.use(VeeValidate);
Vue.component("slick", Slick);
Vue.use(Carousel3d);
Vue.use(GSignInButton);
Vue.use(FBSignInButton);
Vue.use(VueHead);
Vue.use(Meta);
Vue.use(Loading);
Vue.use(VueQrcodeReader);
Vue.component("multiselect", Multiselect);
Vue.use(ReadMore);

Vue.use(VueFacebookPixel);
Vue.component("vue-phone-number-input", VuePhoneNumberInput);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDTN4bmtcbXEqjsv8B0cx2zG15TIz6-03w", //"AIzaSyDpx-CIzu0s5C-gd8Ntp1t3fCldYbo7ccw"//"AIzaSyACDkTbwhQBjD6Ml9fJYEx35ZunrKh8KHQ"
  },
});
Vue.use(VueLocalStorage, {
  name: "persistStore",
});
Vue.config.productionTip = false;
Vue.component("vue-friendly-iframe", VueFriendlyIframe);
Vue.component("v-otp-input", OTPInput);

// Created the Event Bus for the call parent function
export const EventBus = new Vue();

import CryptoJS from "crypto-js";

import _ from "lodash";

// if(window.location.host == "empirecinemas.me" || window.location.host == "empirecinemas.com.sa" || window.location.host == "empire.com.lb"){
//     window.location.href = "https://empirecinemas.com"
// }
var secretKey = "HereIsTheMySecretKey_LOL";
let preimereToken = window.localStorage.getItem("PREIMERE");
// let preimereToken = window.localStorage.getItem("PREIMERE");
if (
  (preimereToken == "null" ||
    preimereToken == null ||
    preimereToken == "false" ||
    preimereToken == false) &&
  window.location.host != "empirepremiere.com"
) {
  window.localStorage.setItem("PREIMERE", "false");

  import("./assets/css/style.css").then((something) => {
    import("./assets/css/responsive.css");
  });
} else {
  if (window.location.host != "empirepremiere.com") {
    window.localStorage.setItem("PREIMERE", "false");

    import("./assets/css/style.css").then((something) => {
      import("./assets/css/responsive.css");
    });
  } else {
    window.localStorage.setItem("PREIMERE", "true");
    import("./assets/css/preimere-css.css").then((something) => {
      import("./assets/css/responsive.css");
    });
  }
}
let uri = window.location.search.substring(1);
let params = new URLSearchParams(uri);
console.log(params.get("lang"), "ytyttuytu");
if (params && params.get("lang")) {
  if (params.get("lang") == "ar") {
    window.localStorage.setItem(
      "language",
      JSON.stringify({
        lang: "ar",
        lang_id: 1,
      })
    );
  } else {
    window.localStorage.setItem(
      "language",
      JSON.stringify({
        lang: "eng",
        lang_id: 2,
      })
    );
  }
}

let langToken = LanguageService.getLanguage() || {
  lang: "eng",
  lang_id: 2,
};
console.log("localStorage.getItem :", window.localStorage.getItem("country"));
let countryId;
let country = CountryService.getCountry();

let languageCheck = window.localStorage.getItem("language");

if (languageCheck) {
  let language_check1 = JSON.parse(window.localStorage.getItem("language"));
  if (language_check1.lang_id == 1) {
    document.title = "دور سينما إمباير: شاهد القوائم وحجز التذاكر الآن!";
  }
}

if (
  !country &&
  !window.localStorage.getItem("country") &&
  window.location.host != "empirepremiere.com" &&
  !window.location.pathname.includes("/mob") &&
  !window.location.pathname.includes("/theatre")
) {
  if (
    window.location.host == "empirepremiere.com" ||
    window.location.host == "lb.empirecinemas.com"
  ) {
    console.log("CountryName", "Lebanon");
    window.localStorage.setItem("CountryName", "Lebanon");
    countryId = 119;
    window.localStorage.setItem(
      "country",
      JSON.stringify({
        CountryID: 119,
      })
    );
    if (!languageCheck.hasOwnProperty("lang_id")) {
      window.localStorage.setItem(
        "language",
        JSON.stringify({
          lang: "eng",
          lang_id: 2,
        })
      );
    }

    if (window.location.host == "empirepremiere.com") {
      window.localStorage.setItem("PREIMERE", true);
    } else if (window.location.host == "lb.empirecinemas.com") {
      window.localStorage.setItem("PREIMERE", false);
    }
  } else if (window.location.host == "ksa.empirecinemas.com") {
    console.log("CountryName", "Saudi Arabia");
    countryId = 230;
    window.localStorage.setItem(
      "country",
      JSON.stringify({
        CountryID: 230,
      })
    );
    if (languageCheck == "") {
      window.localStorage.setItem(
        "language",
        JSON.stringify({
          lang: "eng",
          lang_id: 2,
        })
      );
    }

    window.localStorage.setItem("PREIMERE", false);
  } else if (
    window.location.host == "irq.empirecinemas.com" ||
    (languageCheck && window.location.host == "localhost:8082")
  ) {
    console.log("CountryName", "Iraq");
    window.localStorage.setItem("CountryName", "Iraq");
    countryId = 102;
    window.localStorage.setItem(
      "country",
      JSON.stringify({
        CountryID: 102,
      })
    );
    if (languageCheck == "") {
      window.localStorage.setItem(
        "language",
        JSON.stringify({
          lang: "eng",
          lang_id: 2,
        })
      );
    }

    window.localStorage.setItem("PREIMERE", false);
  } else if (
    window.location.host == "empirecinemas.com" ||
    window.location.host == "localhost:8082"
  ) {
    // router.push({
    //     path: '/landingpage'
    // })
    console.log("object");
  } else {
    // window.location.href = "https://empirecinemas.com";
  }
} else if (
  window.location.host == "empirepremiere.com" ||
  window.location.host == "lb.empirecinemas.com"
) {
  console.log("CountryName", "Lebanon");
  window.localStorage.setItem("CountryName", "Lebanon");
  countryId = 119;
  window.localStorage.setItem(
    "country",
    JSON.stringify({
      CountryID: 119,
    })
  );
  if (languageCheck == "") {
    window.localStorage.setItem(
      "language",
      JSON.stringify({
        lang: "eng",
        lang_id: 2,
      })
    );
  }
} else if (
  window.location.host == "ksa.empirecinemas.com" ||
  window.location.host == "localhost:8082"
) {
  console.log("CountryName", "Saudi Arabia");
  window.localStorage.setItem("CountryName", "Saudi Arabia");
  countryId = 230;
  window.localStorage.setItem(
    "country",
    JSON.stringify({
      CountryID: 230,
    })
  );
  if (languageCheck == "") {
    window.localStorage.setItem(
      "language",
      JSON.stringify({
        lang: "eng",
        lang_id: 2,
      })
    );
  }
} else if (window.location.host == "irq.empirecinemas.com") {
  console.log("CountryName", "Iraq");
  window.localStorage.setItem("CountryName", "Iraq");
  countryId = 102;
  window.localStorage.setItem(
    "country",
    JSON.stringify({
      CountryID: 102,
    })
  );
  if (languageCheck == "") {
    window.localStorage.setItem(
      "language",
      JSON.stringify({
        lang: "eng",
        lang_id: 2,
      })
    );
  }
}

Vue.mixin({
  data: function() {
    return {
      fromQrCode: "",
      langName: langToken["lang"],
      preimereToken: preimereToken,
      CountryID: country ? country["CountryID"] : countryId,
      LOADING: null,
      pr: true,
      allLanguageData:
        country && country["CountryID"] == 230
          ? languageDataksa[langToken["lang"]]
          : languageData[langToken["lang"]],
      secureStore: {
        set: function(key, value) {
          let setEncryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(value),
            secretKey
          ).toString();
          window.localStorage.setItem(key, setEncryptedData);
        },
        get: function(key) {
          let getEncryptedData = window.localStorage.getItem(key);
          if (!_.isNull(getEncryptedData))
            return JSON.parse(
              CryptoJS.AES.decrypt(getEncryptedData, secretKey).toString(
                CryptoJS.enc.Utf8
              )
            );
          return null;
        },
        remove: function(key) {
          window.localStorage.removeItem(key);
        },
      },
      sessionStore: {
        set: function(key, value) {
          let setEncryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(value),
            secretKey
          ).toString();
          window.sessionStorage.setItem(key, setEncryptedData);
        },
        get: function(key) {
          let getEncryptedData = window.sessionStorage.getItem(key);
          if (!_.isNull(getEncryptedData))
            return JSON.parse(
              CryptoJS.AES.decrypt(getEncryptedData, secretKey).toString(
                CryptoJS.enc.Utf8
              )
            );
          return null;
        },
        remove: function(key) {
          window.sessionStorage.removeItem(key);
        },
      },
    };
  },
  mounted() {
    let isQrCodeKeyValue = window.localStorage.getItem("isQrCodeKey");
    if (isQrCodeKeyValue === "InCinemaFB") {
      this.fromQrCode = true;
    } else {
      this.fromQrCode = false;
    }
  },
  computed: {
    languageChange() {
      console.log("object" < "Adasasdas");
      return window.localStorage.getItem("language");
    },
  },
  methods: {
    showLoading: function() {
      this.LOADING = this.$loading.show({
        color: preimereToken == "true" ? "#EDD088" : "#e70d00",
        loader: "dots",
        width: 150,
        height: 150,
        class: "css-loader",
        backgroundColor: "rgba(0, 0, 0, 0.5);",
        opacity: 0.5,
        zIndex: 99999,
      });
      document.body.classList.add("modal-open");
    },

    hideLoading: function() {
      this.LOADING ? this.LOADING.hide() : "";
      document.body.classList.remove("modal-open");
    },
  },
});

//Facebook Pixel Code

// let a = Vue.analytics.fbq.init('3730812843688962', {
//   em: localStorage.getItem('guestE') ? localStorage.getItem('guestE') : '',
// })
// console.log('a',a)

const advancedMatching = {
  em: localStorage.getItem("guestE") ? localStorage.getItem("guestE") : "",
}; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: false, // enable logs
};
ReactPixel.init("3730812843688962", advancedMatching, options);
ReactPixel.pageView(); // For tracking page view

//Google Analytic Events

Vue.use(VueAnalytics, {
  id: "UA-146687859-1",
});

//Snap Chat Events

const userIdentification = {
  user_email: localStorage.getItem("guestE")
    ? localStorage.getItem("guestE")
    : "",
}; // optional
console.log(userIdentification, "Email", localStorage.getItem("guestE"));
const snapoptions = {
  debug: false, // enable logs
};
ReactSnapPixel.init(
  "cba3adc1-8ee4-429a-8530-3c604a6d5f83",
  userIdentification,
  snapoptions
);

//Ticktock Pixel

/* eslint-disable no-new */
let app = new Vue({
  el: "#app",
  router,
  // store,
  template: "<App/>",
  components: {
    App,
  },
});



// WEBPACK FOOTER //
// ./src/main.js